import "./ThemeIcon.css";

import { RootState, useAppDispatch, useAppSelector } from "../../store";

import { appActions } from "../../store/slices/appSlice";
import { klassi } from "../../utils/utils";

export default function ThemeIcon() {
  const theme = useAppSelector((state: RootState) => state.app.theme);

  const dispatch = useAppDispatch();

  const sunClass = klassi({ active: theme === "light" }, "fa fa-sun");
  const moonClass = klassi({ active: theme === "dark" }, "fa fa-moon");

  const onThemeClick = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    dispatch(appActions.theme(newTheme));
  };

  return (
    <div className="theme-icon" onClick={onThemeClick}>
      <i className={sunClass} />
      <i className={moonClass} />
    </div>
  );
}
